import { render, staticRenderFns } from "./viewDocument.vue?vue&type=template&id=7f5f31fe"
import script from "./viewDocument.vue?vue&type=script&lang=js"
export * from "./viewDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports